/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  FetchIssuerMetadataRequestBody,
  FetchIssuerMetadataRequestBody$Outbound,
  FetchIssuerMetadataRequestBody$outboundSchema,
} from "../components/fetchissuermetadatarequestbody.js";

export type FetchOrganizationRemoteSessionIssuerMetadataSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type FetchOrganizationRemoteSessionIssuerMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  fetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody;
};

/** @internal */
export type FetchOrganizationRemoteSessionIssuerMetadataSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const FetchOrganizationRemoteSessionIssuerMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    FetchOrganizationRemoteSessionIssuerMetadataSecurity$Outbound,
    FetchOrganizationRemoteSessionIssuerMetadataSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function fetchOrganizationRemoteSessionIssuerMetadataSecurityToJSON(
  fetchOrganizationRemoteSessionIssuerMetadataSecurity:
    FetchOrganizationRemoteSessionIssuerMetadataSecurity,
): string {
  return JSON.stringify(
    FetchOrganizationRemoteSessionIssuerMetadataSecurity$outboundSchema.parse(
      fetchOrganizationRemoteSessionIssuerMetadataSecurity,
    ),
  );
}

/** @internal */
export type FetchOrganizationRemoteSessionIssuerMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  FetchIssuerMetadataRequestBody: FetchIssuerMetadataRequestBody$Outbound;
};

/** @internal */
export const FetchOrganizationRemoteSessionIssuerMetadataRequest$outboundSchema:
  z.ZodMiniType<
    FetchOrganizationRemoteSessionIssuerMetadataRequest$Outbound,
    FetchOrganizationRemoteSessionIssuerMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      fetchIssuerMetadataRequestBody:
        FetchIssuerMetadataRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        fetchIssuerMetadataRequestBody: "FetchIssuerMetadataRequestBody",
      });
    }),
  );

export function fetchOrganizationRemoteSessionIssuerMetadataRequestToJSON(
  fetchOrganizationRemoteSessionIssuerMetadataRequest:
    FetchOrganizationRemoteSessionIssuerMetadataRequest,
): string {
  return JSON.stringify(
    FetchOrganizationRemoteSessionIssuerMetadataRequest$outboundSchema.parse(
      fetchOrganizationRemoteSessionIssuerMetadataRequest,
    ),
  );
}
